export default {
    isMobileMenu:false,
    isAbout:window.location.href.includes('about') ? true : false,
}